import { useTranslation } from 'react-i18next';
import { Logo } from '../../../web/src/components/navigation/logo.jsx';
import { Button } from '../../../web/src/components/interactive/button.jsx';

const NAV_KEYS = ['nav.transactions', 'nav.accounts', 'nav.schedules', 'nav.reports'];

/**
 * Frames a mockup so it reads as a screenshot of the app: a browser chrome
 * bar and a slim app header with the real Logo and ghost nav buttons. The
 * children (real DataTable / report cards) render in the body.
 * @param {{ url?: string, children: import('react').ReactNode }} props
 * @returns {JSX.Element}
 */
export function MockAppFrame({ url = 'app.thyme.money', children }) {
	const { t } = useTranslation();
	return (
		<div className="mock-frame card">
			<div className="mock-frame-bar">
				<span className="mock-frame-dots" aria-hidden="true">
					<span /><span /><span />
				</span>
				<span className="mock-frame-url">{url}</span>
			</div>
			<div className="mock-app-header">
				<span className="mock-app-brand">
					<Logo size={22} /> Thyme
				</span>
				<span className="mock-app-nav">
					{NAV_KEYS.map((key) => (
						<Button key={key} variant="ghost" size="sm">{t(key)}</Button>
					))}
				</span>
			</div>
			<div className="mock-frame-body">{children}</div>
		</div>
	);
}
